export enum OrganizationRelationshipKind {
  PROMOTER = 'PROMOTER',
  PARTNER = 'PARTNER',
}

export enum ExternalAccountType {
  VENUE = 'VENUE',
  EXTERNAL = 'EXTERNAL',
}

export enum ExternalAccountKind {
  PROMOTER = 'PROMOTER',
  PARTNER = 'PARTNER',
}
